import { useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { PasswordInput } from "@/components/PasswordInput";
import { useAuth } from "@/context/AuthContext";
import { api, errMsg } from "@/lib/api";

const EMPTY = { current_password: "", new_password: "", confirm: "" };

export const ChangePassword = () => {
  const { signIn } = useAuth();
  const [f, setF] = useState(EMPTY);
  const [busy, setBusy] = useState(false);
  const up = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const mismatch = f.confirm && f.new_password !== f.confirm;
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/auth/change-password", { current_password: f.current_password, new_password: f.new_password });
      signIn(data.token, data.user);
      setF(EMPTY);
      toast.success("Password changed. Other devices have been signed out.");
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <form onSubmit={submit} className="card-surface p-6 space-y-3 max-w-md" data-testid="change-password-form">
      <h3 className="font-semibold text-lg">Change password</h3>
      <PasswordInput autoComplete="current-password" placeholder="Current password" value={f.current_password} onChange={up("current_password")} data-testid="current-password-input" />
      <PasswordInput autoComplete="new-password" placeholder="New password (min 8 characters)" value={f.new_password} onChange={up("new_password")} data-testid="new-password-input" />
      <PasswordInput autoComplete="new-password" placeholder="Confirm new password" value={f.confirm} onChange={up("confirm")} data-testid="confirm-password-input" />
      {f.new_password && f.new_password.length < 8 && <p className="text-xs text-slate-500" data-testid="password-length-hint">New password must be at least 8 characters</p>}
      {mismatch && <p className="text-sm text-rose-600" data-testid="password-mismatch">Passwords do not match</p>}
      <Button className="rounded-full" disabled={busy || !f.current_password || f.new_password.length < 8 || f.new_password !== f.confirm} data-testid="change-password-btn">
        {busy ? <Loader2 className="animate-spin" /> : "Update password"}
      </Button>
    </form>
  );
};
